import React, { useEffect } from "react";
import CookieConsent from "react-cookie-consent";
import Cookies from "js-cookie";
import { loadGoogleTagManager } from "../../services/analytics/_GoogleAnalytics";
import { loadGoogleTagManagerNoScript } from "../../services/analytics/_GoogleAnalyticsNoScript";

const GTM_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;

const GTMCookieConsentModal = () => {
    useEffect(() => {        
        if (GTM_ID) {
            loadGoogleTagManager(GTM_ID);
            loadGoogleTagManagerNoScript(GTM_ID);
        }
    }, []);

    return (
        <CookieConsent
            location="bottom"
            buttonText="Close"
            enableDeclineButton={false }
            onAccept={() => {
                console.log("Cookies accepted");
                if (GTM_ID) {
                    loadGoogleTagManager(GTM_ID);
                    loadGoogleTagManagerNoScript(GTM_ID);
                }
            }}            
            cookieName="GTMCookieDisplayed"
            style={{ background: "#f5f3d1", color: "#000", border: "5px solid black", zIndex: 9999 }}
            buttonStyle={{ color: "#fff", background: "#3399ff", border: "2px solid black", fontSize: "13px", margin: "0 0px" }}
            declineButtonStyle={{
                color: "#fff",
                backgroundColor: "grey",
                fontSize: "13px",
                marginRight: "10px",                
            }}
            expires={150}
        >
            We use cookies and similar technologies to recognize your repeat visits and preferences as well as to measure the effectiveness of campaigns and analyze traffic.
            To learn more about cookies, you can view our{" "}
            <a href="https://seapromfg.com/privacy-policy/" target="_blank"><u>privacy policy</u></a> here.
            By continuing to use our site, you consent to the use of cookies.
        </CookieConsent>
    );
};

export default GTMCookieConsentModal;
